import DateTime from 'typescript-dotnet-es6/System/Time/DateTime'
import { CorporateDateRules } from './corporateDateRules'
import { AddDaysToDate } from '../../../../core'

export class DateTimeExtension {
  public static GetLastDayOfMonth(dateTime: DateTime): DateTime {
      return AddDaysToDate(new DateTime( new Date(dateTime.year, dateTime.month, 1)).addMonths(1), -1);
  }
  public static  GetFirstDayOfMonth(dateTime: DateTime): DateTime {
      return new DateTime( new Date(dateTime.year, dateTime.month, 1));
  }
  public static IsLastDayOfTheMonth(dateTime: DateTime): boolean {
      return dateTime == DateTimeExtension.GetLastDayOfMonth(dateTime);
  }
  public static GetNextEnabledMonth(dateTime: DateTime, rule: CorporateDateRules.DateSelectionRule): DateTime {
      var newDateTime: DateTime = DateTimeExtension.GetFirstDayOfMonth(dateTime);
      for (var i: number = 0; i < 12; i++) {
          newDateTime = newDateTime.addMonths(1);
          if (CorporateDateRules.IsMonthEnabled(newDateTime, rule)) {
               return newDateTime;
          }
      }
      return new DateTime(0);
  }
  public static AddMonths(dateTime: DateTime, months: number, rule: CorporateDateRules.DateSelectionRule): DateTime {
      var newDateTime: DateTime = dateTime;
      for (var i: number = 0; i < 12; i++) {
          newDateTime = newDateTime.addMonths(1);
          if (CorporateDateRules.IsMonthEnabled(newDateTime, rule)) {
              months--;
              if (months <= 0)
                  return newDateTime;
          }
      }
      return new DateTime(0);
  }
   public static GotoFirstValidDay(dateTime: DateTime, rule: CorporateDateRules.DateSelectionRule): DateTime {
       if (CorporateDateRules.IsMonthEnabled(dateTime, rule))
           return dateTime;
       return DateTimeExtension.AddMonths(DateTimeExtension.GetFirstDayOfMonth(dateTime),1, rule);
   }
}




